import { TreeDataItem } from "../../../modules/fwcore/models/tree-data-item";
import { SaveState } from "./save-state";

export class ResultSelection extends SaveState {

  /**
   * Unique identifier*.
   */
  id?: string | null;

  /**
   * Name
   */
  name?: string | null;

  /**
   * The data item
   */
  item?: TreeDataItem | null;
}
